import { styled, Typography } from "@mui/material";

export const PaperHeader = styled(Typography)({
  display: "flex",
  alignItems: "center",
  gap: 4,
  minHeight: 24,
});
